import { VerityColorLogo } from "@verity/components/core";
import { useEffect, useState } from "react";
import apiClient from "../../../../helpers/api-client";
import i18n from "../../../../i18n";

export default function FirstPage({
	assessmentOption,
	eventPageCount,
	notePageCount,
	roomScanNoteCount,
	studentName,
	numSummaryPages,
}: {
	assessmentOption: any;
	eventPageCount: number;
	notePageCount: number;
	roomScanNoteCount: number;
	studentName: string | null | undefined;
	/**Number of pages summary page spans */
	numSummaryPages: number;
}) {
	const [name, setName] = useState<string>(
		i18n.t("result.components.resultsPage.proctoringResultsReport.unavailableName"),
	);
	useEffect(() => {
		void (async () => {
			const currentUser = await apiClient.user.getUserInfo();
			setName(
				currentUser.userInfo.full_name ??
					currentUser.userInfo.email ??
					i18n.t("result.components.resultsPage.proctoringResultsReport.unavailableName"),
			);
		})();
	}, []);

	const flaggedEventsStartingPage = numSummaryPages + 2;
	return (
		<div style={{ height: `1187px`, color: "#202124" }}>
			<div style={{ border: "1px solid #C7C7C7", margin: "40px", borderRadius: "10px" }}>
				<div style={{ justifyContent: "center", display: "flex", marginTop: "20px" }}>
					<div style={{ marginTop: "15px" }}>
						<VerityColorLogo width={80} height={80} style={{ marginRight: "20px" }} />
					</div>
					<p style={{ fontSize: "32px", fontWeight: "bold", color: "#42296E" }}>
						{i18n.t("result.components.resultsPage.proctoringResultsReport.title")}
					</p>
				</div>

				<div style={{ justifyItems: "center", marginBottom: "30px", display: "grid" }}>
					<div>
						<div>
							<strong>{i18n.t("result.components.resultsPage.proctoringResultsReport.testTakerName")}</strong>{" "}
							{studentName ?? "Unavailable"}
						</div>
						<div>
							<strong>{i18n.t("result.components.resultsPage.proctoringResultsReport.exportedBy")}</strong> {name}
						</div>
					</div>
				</div>
			</div>

			<div
				style={{
					justifyItems: "center",
					marginTop: "50px",
					display: "grid",
					border: "1px solid #C7C7C7",
					margin: "40px",
					borderRadius: "10px",
				}}
			>
				<p style={{ fontSize: "32px", fontWeight: "bold", color: "#42296E" }}>
					{i18n.t("result.components.resultsPage.proctoringResultsReport.tableOfContents")}
				</p>
			</div>
			<div style={{ marginTop: "50px", marginLeft: "40px" }}>
				<div>
					<div style={{ marginBottom: "25px" }}>
						<div style={{ display: "flow" }}>
							<div style={{ fontSize: "22px", fontWeight: "700" }}>
								{i18n.t("result.components.resultsPage.proctoringResultsReport.sessionSummary")}
							</div>{" "}
							<div style={{ float: "right", marginRight: "40px" }}>2</div>
						</div>
						<div style={{ fontSize: "18px", fontWeight: "400" }}>
							{i18n.t("result.components.resultsPage.proctoringResultsReport.sessionSummaryBody")}
						</div>
					</div>
					<div style={{ marginBottom: "25px" }}>
						<div style={{ display: "flow" }}>
							<div style={{ fontSize: "22px", fontWeight: "700" }}>
								{i18n.t("result.components.resultsPage.proctoringResultsReport.flaggedEvents")}
							</div>{" "}
							<div style={{ float: "right", marginRight: "40px" }}>{flaggedEventsStartingPage}</div>
						</div>
						<div style={{ fontSize: "18px", fontWeight: "400" }}>
							{i18n.t("result.components.resultsPage.proctoringResultsReport.flaggedEventsBody")}
						</div>
					</div>

					{!!notePageCount && (
						<div style={{ marginBottom: "25px" }}>
							<div style={{ display: "flow" }}>
								<div style={{ fontSize: "22px", fontWeight: "700" }}>
									{i18n.t("result.components.resultsPage.proctoringResultsReport.sessionNotes")}
								</div>{" "}
								<div style={{ float: "right", marginRight: "40px" }}>{flaggedEventsStartingPage + eventPageCount}</div>
							</div>
							<div style={{ fontSize: "18px", fontWeight: "400" }}>
								{i18n.t("result.components.resultsPage.proctoringResultsReport.sessionNotesBody")}
							</div>
						</div>
					)}

					{/* TODO: add live session note
					 <div style={{ marginBottom: "25px" }}>
					 <div style={{display: "flow"}}><div style={{ fontSize: "22px", fontWeight: "700" }}>Live Session Notes</div>	<div style={{float: "right", right: "40px"}}>3</div></div>
						<div style={{ fontSize: "18px", fontWeight: "400" }}>
							View notes the proctor added during the live session.
						</div>
					</div> */}

					{!!roomScanNoteCount && (
						<div style={{ marginBottom: "25px" }}>
							<div style={{ display: "flow" }}>
								<div style={{ fontSize: "22px", fontWeight: "700" }}>
									{i18n.t("result.components.resultsPage.proctoringResultsReport.roomScanNotes")}
								</div>{" "}
								<div style={{ float: "right", marginRight: "40px" }}>
									{flaggedEventsStartingPage + eventPageCount + notePageCount}
								</div>
							</div>
							<div style={{ fontSize: "18px", fontWeight: "400" }}>
								{i18n.t("result.components.resultsPage.proctoringResultsReport.roomScanNotesBody")}
							</div>
						</div>
					)}

					{!!assessmentOption?.options?.recordInput && (
						<div style={{ marginBottom: "25px" }}>
							<div style={{ display: "flow" }}>
								<div style={{ fontSize: "22px", fontWeight: "700" }}>
									{i18n.t("result.components.resultsPage.proctoringResultsReport.keystrokeLog")}
								</div>{" "}
								<div style={{ float: "right", marginRight: "40px" }}>
									{flaggedEventsStartingPage + eventPageCount + notePageCount + roomScanNoteCount}
								</div>
							</div>
							<div style={{ fontSize: "18px", fontWeight: "400" }}>
								{i18n.t("result.components.resultsPage.proctoringResultsReport.keystrokeLogBody")}
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
